var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03571 6.71066L12.5259 3.22049C12.9542 2.7922 12.9542 2.0978 12.5259 1.66915L11.7502 0.893485C11.3219 0.465193 10.6275 0.465193 10.1989 0.893485L6.7087 4.38365L3.21854 0.893485C2.79025 0.465193 2.09584 0.465193 1.6672 0.893485L0.891532 1.66915C0.463239 2.09745 0.463239 2.79185 0.891532 3.22049L4.3817 6.71066L0.891532 10.2008C0.463239 10.6291 0.463239 11.3235 0.891532 11.7522L1.6672 12.5278C2.09549 12.9561 2.79025 12.9561 3.21854 12.5278L6.7087 9.03767L10.1989 12.5278C10.6272 12.9561 11.3219 12.9561 11.7502 12.5278L12.5259 11.7522C12.9542 11.3239 12.9542 10.6295 12.5259 10.2008L9.03571 6.71066Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconCertificate);
export default __webpack_public_path__ + "static/media/close-icon-certificate.8ea75bca8c27a743e88b28a165fa964f.svg";
export { ForwardRef as ReactComponent };